export { default as axios } from './axios';



// WEBPACK FOOTER //
// src/store/services/index.js